import { initializeApp } from 'firebase/app'
import { getRemoteConfig, fetchAndActivate, getValue, setCustomSignals } from 'firebase/remote-config'

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDo-2iBOwSMOxkJ5V844A4JBGf74VNzSlA',
  authDomain: 'fb-web-qic.firebaseapp.com',
  projectId: 'fb-web-qic',
  storageBucket: 'fb-web-qic.firebasestorage.app',
  messagingSenderId: '76324519272',
  appId: '1:76324519272:web:c57028814ebaf5048f2add',
  measurementId: 'G-VHSFS6QNTK'
}

const app = initializeApp(FIREBASE_CONFIG)

export const fetchConfig = async (feature) => {
  try {
    const env = process.env.NODE_ENV === 'production' ? window.location.hostname : 'dev'

    const remoteConfig = getRemoteConfig(app)
    remoteConfig.settings.minimumFetchIntervalMillis = 3600000

    await setCustomSignals(remoteConfig, {
      env
    })

    await fetchAndActivate(remoteConfig)

    return getValue(remoteConfig, feature).asBoolean()
  } catch (error) {
    console.error('Ошибка загрузки Remote Config:', error)
  }
}
